<template>
  <div class="item">
    <div v-if="[$c.MISSION_STATUS.FINISHED, $c.MISSION_STATUS.NEW].includes(mission.mission_status)"
         class="mask" :class="[mission.mission_status === $c.MISSION_STATUS.FINISHED ? 'mask_type1' : 'mask_type2']"/>
    <div  v-if="[$c.MISSION_STATUS.FINISHED, $c.MISSION_STATUS.NEW].includes(mission.mission_status)" class="mask_content">
      <div v-if="mission.mission_status === $c.MISSION_STATUS.NEW"
           class="lbl_default7_2 lbl_bold color_white" style="text-align: center">{{ $t('mission.desc_new_mission')}}</div>
      <div v-if="mission.mission_status == $c.MISSION_STATUS.FINISHED" style="position: relative">
        <div class="mission_finish_bonus_pop v-layout center justify-center">
          <img src="/assets/new/ic_pop_bg1.png" style="width: 120px; height: 120px;">
          <label class="lbl_default7 lbl_bold text-align-center" style="letter-spacing: -1px">{{ $t('mission.desc_finished_mission')}}</label>
          <label class="lbl_default lbl_bold color_brown" v-if="mission.bonus_point > 0">
            {{mission_type === $c.MISSION_TYPE.TEACHER_MISSION ? mission.bonus_point :
              mission.bonus_point}}P 적립</label>
        </div>
      </div>
    </div>

    <div class="status_outer">
      <div class="status h-layout align-items-center" :class="[ mission.mission_status === $c.MISSION_STATUS.FINISHED || expireTime < 0 ? 'passed' : 'active']">
        <img src="/assets/new/ic_clock.png" class="img_time2">

        <div v-if="mission.mission_status === $c.MISSION_STATUS.FINISHED">
          <label class="lbl_default lbl_bold color_white" style="margin-left: 8px; line-height: 25px;">{{$t('mission.desc_finished_mission')}}</label>
        </div>
        <div v-else-if="mission.mission_status === $c.MISSION_STATUS.DEADLINE_PASSED">
          <label class="lbl_default lbl_bold color_white" style="margin-left: 8px; line-height: 25px;">{{$t('mission.state_desc_deadline')}}</label>
        </div>
        <div v-else>
          <label class="lbl_default7 lbl_bold color_white" style="margin-left: 8px; line-height: 25px;">{{expireDays}}+D</label>
          <label class="lbl_default lbl_bold color_white" style="margin-left: 8px;">{{ expireRestTimes }}</label>
        </div>
      </div>
    </div>
    <div class="content" style="margin-top: 30px;">
      <label class="lbl_default3 lbl_bold mt-5">{{ lecture.course_name }}<span style="font-size: 0.8em; margin-left: 1em;">{{
      mission.mission_content_type == 'L' || mission_type == 'PM' ? $t('mission.listen_mission') :  $t('mission.note_mission')}}</span></label>
      <div style="height: 10px"/>
      <div class="h-layout align-items-center">
        <subject-badge v-if="lecture.lecture_div === '20'" :label="lecture.plan_subject_name" :border-color="'green1'" :border-width="2" />
        <subject-badge v-else :label="lecture.subject_name" :border-color="'green1'" :border-width="2" />

        <subject-badge v-if="lecture.school_div === '10'" :label="lecture.school_div_name | convertSchoolGrade" :border-color="'yellow'" :border-width="2" />
        <subject-badge v-if="lecture.school_div === '20'" :label="lecture.school_div_name | convertSchoolGrade" :border-color="'green'" :border-width="2" />
        <subject-badge v-if="lecture.school_div === '99'" :label="lecture.school_div_name | convertSchoolGrade" :border-color="'blue'" :border-width="2" />
        <img src="/assets/new/ic_play.png" class="ml-2 img_play" @click="playLectureMini">
        <div style="flex: 1"/>
        <template  v-if="mission.bonus_point > 0">
          <label class="lbl_default6 lbl_bold mr-3">{{ $t('listen_teacher.savable_point') }}</label>
          <label class="lbl_default7_2 lbl_bold color_brown">{{mission_type === $c.MISSION_TYPE.TEACHER_MISSION ? mission.bonus_point : mission.bonus_point}}P</label>
        </template>
      </div>
    </div>
    <div class="w100 h-layout mt-3">
      <button class="btn cancel lbl_default7 lbl_bold" style="flex: 1" @click="reject_mission">{{ $t('listen_teacher.i_will_not') }}</button>
      <button class="btn start lbl_default7 lbl_bold" style="flex: 1;" @click="start_mission">{{ $t('listen_teacher.start') }}</button>
    </div>
  </div>
</template>

<script>
import SubjectBadge from "@/components/SubjectBadge";
import * as ajax from "@/utils/ajax";
import * as utils from "@/utils/utils";
import * as biz from "@/utils/biz";

export default {
  name: "MissionCardItem",
  components: {SubjectBadge},
  props: {
    bonus: {
      type: Number,
      default: 50,
    },
    mission: {
      type: Object,
      default: () => {
        return {
          state: this.$c.MISSION_STATUS.PENDING
        }
      }
    },
    lecture: {
      type: Object,
      default: () => {}
    },
    mission_type: String,
    season_info: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    reject_mission() {
      ajax.Get(this, "/api/mission/reject/" + this.mission.mission_no + "/" + this.mission_type, (ref,data) => {
        ref.$emit('onRejectMission', ref.mission.mission_no);
      })
    },
    playLectureMini(e) {
      e.stopPropagation();
      biz.playAudioPlayer(this.lecture.course_no, 'mini');
      this.$store.state.showMissionPopup = false;
    },
    start_mission() {
      ajax.Post(this, "/api/mission/start", {mission_type: this.mission_type,
        mission_no: this.mission.mission_no, lecture_no: this.lecture.course_no}, (ref, data) => {
        ref.$store.state.showMissionPopup = false;
        if (ref.mission_type === "PM"){
          biz.playAudioPlayer(ref.lecture.course_no);
        } else {
          if (ref.mission.mission_content_type == 'L')
            biz.playAudioPlayer(ref.lecture.course_no);
          else
            ref.$router.push({path: '/listen/listen_note_detail', query: {mission_no: ref.mission.mission_no,
              course_no: ref.lecture.course_no}});
        }
      });
    }
  },
  filters:{
    convertSchoolGrade(value) {
      return utils.convertSchoolGrade(value);
    },
  },
  computed: {
    expireDays() {
      return Math.floor(this.expireTime / (3600 * 24))
    },
    expireRestTimes() {
      let rest_time, hour, minute, second;
      rest_time = this.expireTime % (3600 * 24)
      hour = Math.floor(rest_time / 3600);
      minute = Math.floor ((rest_time % 3600) / 60);
      second = rest_time % 60;
      return hour + ": " + minute + ": " + second
    }
  },
  data() {
    return {
      expireTime: this.mission.mission_remain_time
    }
  }
}
</script>

<style scoped lang="scss">
.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 1;
  left: 0;
  top: 0;
  border-radius: 13px;
}
.mask_content {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask_type1 {
  background-color: $primary-color;
}
.mask_type2 {
  background-color: $font-fifth-color;
}
.mission_finish_bonus_pop {
  width: 130px;
  height: 130px;
  position: relative;
  img {
    position: absolute;
    z-index: -1;
  }
}
.item {
  position: relative;
  border: 2px solid #ced4da;
  border-radius: 15px;
  margin-top: 20px;
  margin-bottom: 50px;

  .status_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 0;
    top: -24px;
    width: 100%;
    z-index: 100;
  }
  .status {
    display: flex;
    box-shadow: 0 9px 18px 6px rgba(0, 0, 0, 0.2);
    width: fit-content;
    padding: 8px 20px;
    border-radius: 20px;
  }

  .status.active {
    background: linear-gradient(90deg, #ffb308, #ff7e15);
  }

  .status.passed {
    background: linear-gradient(90deg, #CED4DA, #868E95);
  }

  .content {
    padding: 0 15px;
  }
  .btn {
    padding-bottom: 20px;
    padding-top: 20px;
  }
  button.cancel {
    border-bottom-left-radius: 13px;
    background-color: #f1f3f5;
  }

  button.start {
    border-bottom-right-radius: 13px;
    background-color: #ff7e15;
    color: white;
  }
}
</style>